import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ResponsivePicture from "../../helpers/ResponsivePicture.jsx";
class GfywElement extends React.Component {
	constructor(props) {
		super(props);

		const { content } = this.props;

		this.state = {
			url: "",
			embed: ``,
			url_icon: "fa fa-clipboard",
			embed_icon: "fa fa-clipboard",
			imagen_icon: "fa fa-clipboard"
		};
		this.animateCopy = this.animateCopy.bind(this);
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		const { embed, img } = nextProps;
		const { url_icon, embed_icon, imagen_icon } = prevState;

		if (embed != prevState.content) {
			return {
				url: embed,
				/* prettier-ignore */
				embed: `<iframe src="${embed}" width="${nextProps.size.width ? nextProps.size.width : 640}" height="${nextProps.size.height ? nextProps.size.height : 480}" marginwidth="0" marginheight="0" hspace="0" vspace="0" frameborder="0" scrolling="no" webkitallowfullscreen="true" mozallowfullscreen="true" msallowfullscreen="true" allowfullscreen="true" />`,
				url_icon,
				embed_icon,
				imagen_icon,
				imagen: "https:" + img
			};
		}
	}

	handleFocus(event) {
		event.target.select();
	}
	animateCopy(icon) {
		this.setState({ [icon]: "fadeIn fa fa-check" });
		setTimeout(_ => {
			this.setState({ [icon]: "fadeIn fa fa-clipboard" });
			setTimeout(_ => {
				this.setState({ [icon]: "fa fa-clipboard" });
			}, 500);
		}, 500);
	}
	render() {
		var $tags = [];
		this.props.tags.forEach((result, key) => {
			$tags.push(
				<div
					key={key}
					className={"gameThumbnail-status gameThumbnail-status--" + result}
				/>
			);
		});
		let clases = "Gfyw-element ";

		if (this.props.mobile) {
			clases += " available-mobile";
		}

		return (
			<li className={clases}>
				<div
					className={
						this.props.video ? "gameThumbnail hasVideo" : "gameThumbnail"
					}
				>
					<a href={this.props.embed} target="_blank">
						<span className="gameThumbnail-tags">
							{$tags}

							{this.props.saga ? (
								<div className="gameThumbnail-saga">{this.props.saga}</div>
							) : null}
						</span>
						<ResponsivePicture
							route={this.props.img}
							key={this.props.img}
							width="140"
							height="105"
							isRetina={window.isRetinadisplay}
						/>
						{this.props.video ? (
							<video
								src={this.props.video}
								loop
								preload="none"
								poster={
									window.cdns[0] + "public/images/spinners/loading-136.svg"
								}
								muted=""
								itemProp="trailer"
								itemType="https://schema.org/VideoObject"
							>
								<source
									src={this.props.video}
									type="video/mp4"
									itemProp="contentUrl"
								/>
							</video>
						) : null}
					</a>
				</div>
				<div className="Gfyw-element-data">
					<div className="Gfyw-element-data-element Gfyw-element-data-title">
						{translate.title}: {this.props.name}
					</div>
					<div className="Gfyw-element-data-element Gfyw-element-data-url">
						<div>{translate.URL}:</div>
						<input value={this.state.url} readOnly onFocus={this.handleFocus} />
						<CopyToClipboard
							text={this.state.url}
							onCopy={() => {
								this.animateCopy("url_icon");
							}}
						>
							<button>
								<i className={this.state.url_icon} /> {translate.copiar}
							</button>
						</CopyToClipboard>
					</div>
					<div className="Gfyw-element-data-element Gfyw-element-data-embed">
						<div>{translate.embed}:</div>
						<textarea
							readOnly
							onFocus={this.handleFocus}
							value={this.state.embed}
						/>
						<CopyToClipboard
							text={this.state.embed}
							onCopy={() => {
								this.animateCopy("embed_icon");
							}}
						>
							<button>
								<i className={this.state.embed_icon} /> {translate.copiar}
							</button>
						</CopyToClipboard>
					</div>

					<div className="Gfyw-element-data-element Gfyw-element-data-embed_mobile">
						<div>
							{translate.URL} {translate.imagen}:
						</div>
						<input
							readOnly
							onFocus={this.handleFocus}
							value={this.state.imagen}
						/>
						<CopyToClipboard
							text={this.state.imagen}
							onCopy={() => {
								this.animateCopy("imagen_icon");
							}}
						>
							<button>
								<i className={this.state.imagen_icon} /> {translate.copiar}
							</button>
						</CopyToClipboard>
					</div>
				</div>
			</li>
		);
	}
}

export default GfywElement;
